<script setup lang="ts">
import RegionsMap from '@/components/RegionsMap.vue'
import LocationFilters from '@/components/LocationFilters.vue'
import ResultTable from './ResultTable.vue'
import { useScroll } from '@vueuse/core'
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useLocationStore } from '@/stores/useLocationStore'

const locationStore = useLocationStore()
const resultSectionRef = ref<HTMLElement | null>(null)
const SCROLL_DELAY_MS = 500
const SCROLL_OFFSET_PX = 40
let scrollTimeoutId: ReturnType<typeof setTimeout> | null = null
const { y } = useScroll(window, { behavior: 'smooth' })

watch(
  () => locationStore.selectedStreet,
  async (newStreet, oldStreet) => {
    if (!newStreet || newStreet === oldStreet) {
      return
    }

    await nextTick()

    if (scrollTimeoutId) {
      clearTimeout(scrollTimeoutId)
    }

    scrollTimeoutId = setTimeout(() => {
      const resultTop = resultSectionRef.value?.getBoundingClientRect().top
      if (typeof resultTop !== 'number') {
        return
      }

      y.value = resultTop + window.scrollY - SCROLL_OFFSET_PX
    }, SCROLL_DELAY_MS)
  },
)

onMounted(() => {
  console.info('Component mounted, loading data by url params, fetching regions...')
  locationStore.loadByUrlParams() // Read URL parameters on initial load to handle direct links
})

onBeforeUnmount(() => {
  if (scrollTimeoutId) {
    clearTimeout(scrollTimeoutId)
  }
})
</script>

<template>
  <div class="app-container">
    <RegionsMap />
    <LocationFilters />
    <div ref="resultSectionRef" class="result-section">
      <ResultTable />
    </div>
  </div>
</template>

<style scoped>

.app-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;

  gap: 16px;

  h2 {
    text-align: center;
    margin: 0;
  }
}

.result-section {
  width: 100%;
}

</style>
